import {border, color} from '@chakra-ui/react'

export default {
    parts: [
        'orderErrorContainer',
        'orderErrorContentWrapper',
        'orderErrorHeading',
        'orderErrorDescription',
        'newArrivalButton',
        'newArrivalButtonText'
    ],
    baseStyle: (props) => ({
        orderErrorContainer: {
            display: 'flex',
            flexDirection: 'column',
            width: {base: 'full', lg: '458px'},
            alignItems: 'flexStart',
            margin: {base: '60px auto', lg: '60px auto'},
            padding: {base: '0 16px', lg: '0'},
            gap: '60px'
        },
        orderErrorContentWrapper: {
            display: 'flex',
            flexDirection: 'column',
            gap: '8px'
        },
        orderErrorHeading: {
            fontSize: {base: '16px', lg: '16px'},
            fontWeight: {base: '400', lg: '400'},
            lineHeight: {base: '24px', lg: '24px'}
        },
        orderErrorDescription: {
            fontSize: {base: '12px', lg: '12px'},
            fontWeight: {base: '400', lg: '400'},
            lineHeight: {base: '16px', lg: '16px'}
        },
        newArrivalButton: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            minWidth: '338px',
            width: '100%',
            height: '44px',
            border: '1px solid gray.400',
            bg: 'warmBlack',
            textTransform: 'capitalize',
            padding: '13px 12px',
            color: 'white',
            _hover: {
                bg: 'white',
                border: '1px solid black',
                color: 'black'
            }
        },
        newArrivalButtonText: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: '8px',
            fontSize: {base: '12px', md: '14px'},
            lineHeight: '20px',
            fontWeight: '400'
        }
    })
}
